import React from 'react';
import Helmet from 'react-helmet';
import { Layout, Card } from 'antd';
import BreadcrumbNav from '../BreadcrumbNav';
import Header from '../Header';
import Footer from '../Footer';
import './main.css';
import icon from '../../../assets/favicon.ico';
import constants from '../../../core/constants';
import Sider from '../Sider';
import { MainProps } from './types';

const {
    APP_NAME,
} = constants;

const Main = (props:MainProps) => {

    const {
        children,
        title,
        toolbar,
        breadcrumb,
        className,
        backLink,
        showHeader,
        beforeHeader,
        afterHeader,
        floatingHeader,
        headerTitle,
        showFooter,
        beforeFooter,
        afterFooter,
        floatingFooter,
        footerContent,
        menuPlacement,
        menuWidth,
        isPublic,
    } = props;

    return (
        <div className={`page-wrap ${className}`}>
            <Helmet
                title={typeof title === 'object' ? title.props.children : title}
                titleTemplate={`%s - ${APP_NAME}`}
                defaultTitle={`${APP_NAME}`}
                meta={[
                    { name: 'description', content: `${APP_NAME} website` },
                    { property: 'og:type', content: 'website' },
                ]}>
                <link rel="shortcut icon" href={icon} />
            </Helmet>
            <Layout style={{ minHeight: '100vh' }}>
                {!isPublic && <Sider />}
                <Layout className="main-layout">
                    {showHeader
                        ? (
                            <Header
                                isPublic={isPublic}
                                afterHeader={afterHeader}
                                beforeHeader={beforeHeader}
                                floating={floatingHeader}
                                title={headerTitle || title}
                                toolbar={toolbar}
                                backLink={backLink}
                                menuPlacement={menuPlacement}
                                menuWidth={menuWidth} />
                        )
                        : null}
                    <Layout.Content className="main-content">
                        {breadcrumb ? <BreadcrumbNav navigation={breadcrumb} /> : null}
                        {children}
                        <Card
                            bordered={false}
                            className="main-content__copyright-card">
                            <div className="main-content__copyright-header">
                                <span className="main-content__copyright-symbol">©</span>
                                <span className="main-content__copyright-title">
                                    2026 Šiaulių švietimo kompetencijų centras. Visos teisės saugomos.
                                </span>
                            </div>
                            <p className="main-content__copyright-text">
                                VKSIS (Veiklos kokybės stebėsenos informacinė sistema), jos struktūra, dizainas, duomenų apdorojimo sprendimai ir
                                turinys yra saugomi autorių teisių. Be raštiško teisių turėtojo leidimo draudžiama sistemą kopijuoti, platinti,
                                modifikuoti ar naudoti komerciniais tikslais.
                            </p>
                        </Card>
                    </Layout.Content>
                    {showFooter
                        ? (
                            <Footer
                                beforeFooter={beforeFooter}
                                afterFooter={afterFooter}
                                floating={floatingFooter}>
                                {footerContent}
                            </Footer>
                        )
                        : null}
                </Layout>
            </Layout>
        </div>
    );
};

Main.defaultProps = {
    afterFooter: null,
    afterHeader: null,
    beforeFooter: null,
    beforeHeader: null,
    logo: '',
    showFooter: true,
    showHeader: true,
    isPublic: false,
};

export default Main;
